import {
  BiddingGroupingTypes,
  CommentDataTypes,
  EdictsTypes,
  ElectronicTradingTypes,
  FollowupTypes,
  GestaoTypes,
  ModalityTypes,
  PhoneTypes,
  PublicBodyTypes,
  StatusBiddingInfoTypes,
} from '../bidding_store/types';

export enum BulletinsTypes {
  FETCH_BULLETINS_REQUEST = '@bulletins/FETCH_BULLETINS_REQUEST',
  FETCH_BULLETINS_SUCCESS = '@bulletins/FETCH_BULLETINS_SUCCESS',
  FETCH_BULLETINS_FAILURE = '@bulletins/FETCH_BULLETINS_FAILURE',
  FETCH_BULLETINS_REPRESENTED_REQUEST = '@bulletins/FETCH_BULLETINS_REPRESENTED_REQUEST',
  FETCH_BULLETINS_REPRESENTED_SUCCESS = '@bulletins/FETCH_BULLETINS_REPRESENTED_SUCCESS',
  FETCH_BULLETINS_REPRESENTED_FAILURE = '@bulletins/FETCH_BULLETINS_REPRESENTED_FAILURE',
  FETCH_BULLETIN_CONTENT_REQUEST = '@bulletins/FETCH_BULLETIN_CONTENT_REQUEST',
  FETCH_BULLETIN_CONTENT_SUCCESS = '@bulletins/FETCH_BULLETIN_CONTENT_SUCCESS',
  FETCH_BULLETIN_CONTENT_FAILURE = '@bulletins/FETCH_BULLETIN_CONTENT_FAILURE',
  FETCH_BULLETIN_CONTENT_BY_ID_REQUEST = '@bulletins/FETCH_BULLETIN_CONTENT_BY_ID_REQUEST',
  FETCH_BULLETIN_CONTENT_BY_ID_SUCCESS = '@bulletins/FETCH_BULLETIN_CONTENT_BY_ID_SUCCESS',
  FETCH_BULLETIN_CONTENT_BY_ID_FAILURE = '@bulletins/FETCH_BULLETIN_CONTENT_BY_ID_FAILURE',
  FETCH_BULLETIN_BIDDINGS_REQUEST = '@bulletins/FETCH_BULLETIN_BIDDINGS_REQUEST',
  FETCH_BULLETIN_BIDDINGS_SUCCESS = '@bulletins/FETCH_BULLETIN_BIDDINGS_SUCCESS',
  FETCH_BULLETIN_BIDDINGS_FAILURE = '@bulletins/FETCH_BULLETIN_BIDDINGS_FAILURE',
  FETCH_BULLETIN_FOLLOWUPS_REQUEST = '@bulletins/FETCH_BULLETIN_FOLLOWUPS_REQUEST',
  FETCH_BULLETIN_FOLLOWUPS_SUCCESS = '@bulletins/FETCH_BULLETIN_FOLLOWUPS_SUCCESS',
  FETCH_BULLETIN_FOLLOWUPS_FAILURE = '@bulletins/FETCH_BULLETIN_FOLLOWUPS_FAILURE',
  SET_BULLETIN_READ = '@bulletins/SET_BULLETIN_READ',
  CLEAR = '@bulletins/CLEAR',
  UPDATE_CURRENT_PAGE_BIDDINGS = '@bulletins/UPDATE_CURRENT_PAGE_BIDDINGS',
  UPDATE_CURRENT_PAGE_FOLLOWUPS = '@bulletins/UPDATE_CURRENT_PAGE_FOLLOWUPS',
  CREATE_BIDDING_FAVORITE_REQUEST = '@bulletins/CREATE_BIDDING_FAVORITE_REQUEST',
  CREATE_BIDDING_FAVORITE_SUCCESS = '@bulletins/CREATE_BIDDING_FAVORITE_SUCCESS',
  CREATE_BIDDING_FAVORITE_FAILURE = '@bulletins/CREATE_BIDDING_FAVORITE_FAILURE',
  DESTROY_BIDDING_FAVORITE_REQUEST = '@bulletins/DESTROY_BIDDING_FAVORITE_FAILURE',
  DESTROY_BIDDING_FAVORITE_SUCCESS = '@bulletins/DESTROY_BIDDING_FAVORITE_SUCCESS',
  DESTROY_BIDDING_FAVORITE_FAILURE = '@bulletins/DESTROY_BIDDING_FAVORITE_FAILURE',
  GET_COMMENTS_REQUEST = '@bulletins/GET_COMMENTS_REQUEST',
  GET_COMMENTS_SUCCESS = '@bulletins/GET_COMMENTS_SUCCESS',
  GET_COMMENTS_FAILURE = '@bulletins/GET_COMMENTS_FAILURE',
  CREATE_COMMENT_REQUEST = '@bulletins/CREATE_COMMENT_REQUEST',
  CREATE_COMMENT_SUCCESS = '@bulletins/CREATE_COMMENT_SUCCESS',
  CREATE_COMMENT_FAILURE = '@bulletins/CREATE_COMMENT_FAILURE',
  DESTROY_COMMENT_REQUEST = '@bulletins/DESTROY_COMMENT_REQUEST',
  DESTROY_COMMENT_SUCCESS = '@bulletins/DESTROY_COMMENT_SUCCESS',
  DESTROY_COMMENT_FAILURE = '@bulletins/DESTROY_COMMENT_FAILURE',
  CREATE_MANAGED_REQUEST = '@bulletins/CREATE_MANAGED_REQUEST',
  CREATE_MANAGED_SUCCESS = '@bulletins/CREATE_MANAGED_SUCCESS',
  CREATE_MANAGED_FAILURE = '@bulletins/CREATE_MANAGED_FAILURE',
  DESTROY_MANAGED_REQUEST = '@bulletins/DESTROY_MANAGED_REQUEST',
  DESTROY_MANAGED_SUCCESS = '@bulletins/DESTROY_MANAGED_SUCCESS',
  DESTROY_MANAGED_FAILURE = '@bulletins/DESTROY_MANAGED_FAILURE',
  CREATE_VIEWED_BIDDING_REQUEST = '@bulletins/CREATE_VIEWED_BIDDING_REQUEST',
  CREATE_VIEWED_BIDDING_SUCCESS = '@bulletins/CREATE_VIEWED_BIDDING_SUCCESS',
  CREATE_VIEWED_BIDDING_FAILURE = '@bulletins/CREATE_VIEWED_BIDDING_FAILURE',
  DESTROY_VIEWED_BIDDING_REQUEST = '@bulletins/DESTROY_VIEWED_BIDDING_REQUEST',
  DESTROY_VIEWED_BIDDING_SUCCESS = '@bulletins/DESTROY_VIEWED_BIDDING_SUCCESS',
  DESTROY_VIEWED_BIDDING_FAILURE = '@bulletins/DESTROY_VIEWED_BIDDING_FAILURE',
  OVERVIEW_REQUEST = '@bulletins/OVERVIEW_REQUEST',
  OVERVIEW_SUCCESS = '@bulletins/OVERVIEW_SUCCESS',
  OVERVIEW_FAILURE = '@bulletins/OVERVIEW_FAILURE',
  INITIAL_STATE = '@bulletins/INITIAL_STATE',
  SEND_IA_MESSAGE_REQUEST = '@bulletins/SEND_IA_MESSAGE_REQUEST',
  SEND_IA_MESSAGE_SUCCESS = '@bulletins/SEND_IA_MESSAGE_SUCCESS',
  SEND_IA_MESSAGE_FAILURE = '@bulletins/SEND_IA_MESSAGE_FAILURE',
  CLEAR_IA_MESSAGES = '@bulletins/CLEAR_IA_MESSAGES',
  CLEAR_IA_TOOL_ACTION = '@bulletins/CLEAR_IA_TOOL_ACTION',
  SET_IA_MESSAGES = '@bulletins/SET_IA_MESSAGES',
  SET_IA_APPLIED_FILTER = '@bulletins/SET_IA_APPLIED_FILTER',
  CLEAR_IA_APPLIED_FILTER = '@bulletins/CLEAR_IA_APPLIED_FILTER',
  SET_STATUS_FILTER = '@bulletins/SET_STATUS_FILTER',
  SET_MATCH_ONLY_FILTER = '@bulletins/SET_MATCH_ONLY_FILTER',
  MARK_ALL_BULLETINS_READ_REQUEST = '@bulletins/MARK_ALL_BULLETINS_READ_REQUEST',
  MARK_ALL_BULLETINS_READ_SUCCESS = '@bulletins/MARK_ALL_BULLETINS_READ_SUCCESS',
  MARK_ALL_BULLETINS_READ_FAILURE = '@bulletins/MARK_ALL_BULLETINS_READ_FAILURE',
}
export interface BiddingContractFile {
  id: number;
  url: string;
  document_type_name: string;
  document_title: string;
  publication_date_pncp: string;
}
export interface BiddingContract {
  id: number;
  nome_fornecedor: string;
  valor_contratado: number;
  data_assinatura: string;
  vigencia_inicio: string;
  vigencia_fim: string;
  files: BiddingContractFile[];
}

export interface BulletinTypes {
  closing_date: string;
}

export interface BulletinFilterTypes {
  'alowed_reading?': boolean;
  bulletin: BulletinTypes;
  bulletin_id: number;
  created_at: string;
  filter_id: number;
  id: number;
  issue: number;
  previous_bulletin_id: number | null;
  read: boolean;
  read_by: boolean;
  updated_at: string;
  previous_bulletin_filter_id: number | null;
  next_bulletin_filter_id: number | null;
}

export interface FiltersTypes {
  afternoon: boolean;
  bidding_filterable_id: number;
  bidding_filterable_type: string;
  client_id: number;
  created_at: string;
  description: string;
  followup_filterable_id: number;
  followup_filterable_type: string;
  id: number;
  last_bulletin_id: number;
  morning: boolean;
  next_issue: number;
  night: boolean;
  pr_next_issue_offset: number;
  schedule_limit: number | null;
  send_all_open: boolean;
  subject_description: false;
  updated_at: string;
}

export interface FilterBulletinTypes {
  bidding_keywords: Array<string>;
  followup_keywords: Array<string>;
  bulletin_filters: Array<BulletinFilterTypes>;
  filter: FiltersTypes;
  months: Array<string>;
}

export interface HighlightsJsonTypes {
  count: number;
  highlights: Array<string>;
}

export interface ManagedBy {
  user_id: number;
  name: string;
}

export interface MonitoredBy {
  user_id: number;
  name: string;
}

export type MatchPrioridade = 'Alta' | 'Média' | 'Baixa' | 'não avaliada';

export interface MatchTypes {
  prioridade: MatchPrioridade;
  compatibilidade?: number;
  regiao_atuacao?: boolean;
  n_itens: number;
  /** Itens do edital compatíveis com o que o cliente fornece (o porquê do selo). */
  itens_compativeis?: string[];
  indicadores: {
    regiao: string | null;
  };
  explicacao: string;
}

export interface MatchResumoTypes {
  Alta?: number;
  Média?: number;
  Baixa?: number;
  'não avaliada'?: number;
}

export interface BulletinBiddingsTypes {
  atividade: string;
  atividade_processamento: string;
  bidding_id: number;
  total_managed_opened_tasks?: number;
  bulletin_id: number;
  concorrentes_internacionais: boolean;
  created_at: string;
  created: string;
  datahora_validade: string;
  datahora_abertura: string | null;
  data_validade: string | null;
  created_at_controle: string | null;
  datahora_documento: string | null;
  datahora_prazo: string;
  datahora_processamento: string | null;
  datahora_retirada: string | null;
  datahora_visita: string | null;
  delete_user: number;
  edital: string;
  edital_alterado: string | null;
  edital_datahora: string;
  edital_email: string;
  edital_funcionario: string;
  edital_homepage1: string;
  edital_homepage2: string;
  edital_posterior: number | null;
  edital_preco: number;
  edital_site: string;
  edital_status_id: number;
  edital_tem: boolean;
  edital_tempo_real: number | null;
  email: string;
  enviar: number | null;
  favorited: boolean;
  favorited_by: Array<string>;
  viewed_by_user: boolean;
  viewed_by: Array<string>;
  fonte_id: number | null;
  gestao?: GestaoTypes;
  has_electronic_trading: boolean;
  highlights_json: HighlightsJsonTypes | null;
  id: number;
  itens: string;
  liberado: boolean;
  managed: boolean;
  client_comments: Array<CommentDataTypes>;
  modalidade_id: number;
  modified: string | null;
  monitored_by_user: boolean;
  motivo_pendencia: string | null;
  objeto: string;
  observacao: string;
  observacao_interna: string;
  orgao_cep: string;
  orgao_cidade: string;
  orgao_cidade_id: number;
  orgao_classe: string;
  orgao_endereco: string;
  orgao_estado: string;
  orgao_estado_id: number;
  orgao_exigencia: string;
  orgao_id: number;
  orgao_local: string;
  orgao_uasg: string;
  pendente: boolean;
  processo: string;
  tem_acompanhamento: boolean;
  tipo_agrupamento_id: number;
  tipo_orgao_id: number;
  tipo_valor_estimado_id: number | null;
  updated_at: string;
  valor_estimado: number;
  electronic_trading: ElectronicTradingTypes;
  bidding_grouping: BiddingGroupingTypes;
  edicts: Array<EdictsTypes>;
  has_summary: boolean;
  faxes: Array<PhoneTypes>;
  followups: Array<FollowupTypes> | null;
  modality: ModalityTypes;
  phones: Array<PhoneTypes>;
  public_body: PublicBodyTypes;
  status_bidding_info: Array<StatusBiddingInfoTypes>;
  has_requested_edital: boolean;
  contracts: BiddingContract[];
  indexed_for_ai: boolean;
  managers: Array<ManagedBy>;
  monitors: Array<MonitoredBy>;
  garantia_proposta: boolean | null;
  garantia_contrato: boolean | null;
  match?: MatchTypes | null;
}

export interface SingleBulletinBiddingTypes {
  biddings: Array<BulletinBiddingsTypes>;
  current_page: number;
  total_pages: number;
  total_entries: number;
  biddings_ids: Array<number>;
  match_enabled?: boolean;
  match_resumo?: MatchResumoTypes;
}

export interface BulletinFollowupTypes {
  atividade: string;
  bidding_id: number;
  bulletin_id: number;
  created_at: string;
  data_fonte: string | null;
  datahora_processamento: string | null;
  delete_user: number | null;
  edital: string;
  enviar: boolean;
  followup_id: number;
  fonte_id: number;
  id: number;
  liberado: boolean;
  licitacao_fonte_id: number | null;
  modalidade_id: number;
  motivo_pendencia: string;
  objeto: string;
  observacao_interna: string;
  orgao_cidade: string;
  orgao_cidade_id: number;
  orgao_estado: string;
  orgao_estado_id: number;
  orgao_id: number;
  pendente: boolean;
  processo: string;
  public_body: PublicBodyTypes;
  sintese: string;
  tipo_orgao_id: number;
  updated_at: string;
}

export interface SingleBulletinFollowupTypes {
  followups: Array<BulletinFollowupTypes>;
  current_page: number;
  total_pages: number;
  total_entries: number;
  followups_ids: Array<number>;
}

export interface SingleBulletinBiddingList {
  [key: string]: SingleBulletinBiddingTypes;
}

export interface SingleBulletinFollowupList {
  [key: string]: SingleBulletinFollowupTypes;
}

export interface IaChatMessageTypes {
  role: 'user' | 'assistant';
  content: string;
}

export interface IaChatToolAction {
  tool: string;
  name?: string;
  filters: {
    objeto: string;
    notWord: string;
    states: number[];
    cities: number[];
    validityStart: string;
    validityEnd: string;
    situations: number[];
    status: boolean[];
    orgao: string;
    esfera: number[];
    publicationStart: string;
    publicationEnd: string;
  };
}

export interface IaAppliedFilter {
  name: string;
  chatHistory: Array<IaChatMessageTypes>;
}

export interface MyBulletinsTypes {
  filter_bulletins: Array<FilterBulletinTypes>;
  bulletins_biddings_list: SingleBulletinBiddingList;
  bulletins_followups_list: SingleBulletinFollowupList;
  total: number;
  by_region: Record<number, number>;
  by_esfera: Record<number, number>;
  by_modality: Array<{ label: string; total: number }>;
  by_situation: Array<{ label: string; total: number }>;
  by_portal: Array<{ label: string; total: number }>;
  ia_chat_messages: Array<IaChatMessageTypes>;
  ia_chat_tool_action: IaChatToolAction | null;
  ia_applied_filter: IaAppliedFilter | null;
  status_filter: Array<boolean>;
  /** Modo Match: exibir apenas licitações compatíveis (filtro client-side). */
  match_only_filter: boolean;
}

export interface RequestTypes {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RequestState {
  fetch_bulletin_filters: RequestTypes;
  fetch_bulletin_content: RequestTypes;
  fetch_bulletin_content_by_id: RequestTypes;
  fetch_bulletin_biddings: {
    [key: string]: RequestTypes;
  };
  fetch_bulletin_followups: {
    [key: string]: RequestTypes;
  };
  create_bidding_favorite_bulletin: RequestTypes;
  destroy_bidding_favorite_bulletin: RequestTypes;
  destroy_bidding_managed_bulletin: RequestTypes;
  create_viewed_bidding_bulletin: RequestTypes;
  destroy_viewed_bidding_bulletin: RequestTypes;
  mark_all_bulletins_read: RequestTypes;
  overview: RequestTypes;
  ia_chat: RequestTypes;
}

export interface CommentsRequestState {
  get_comments_bulletin: RequestTypes;
  create_comment_bulletin: RequestTypes;
  destroy_comment_bulletin: RequestTypes;
}

export interface IndividualCommentRequestState {
  [key: string]: CommentsRequestState;
}

export interface BulletinsState {
  readonly request: RequestState;
  readonly bulletins: MyBulletinsTypes;
  readonly comments_request: IndividualCommentRequestState;
}
